<template>
	<base-button :class="['button-reasoning', { 'button-reasoning--on': active && changeColor }]">
		<svg-icon class="button-reasoning-lamp" name="reasoning" :size="16" />
		<p class="tag-card-name">Мышление</p>
		<svg-icon
			v-if="showChevron"
			:class="['button-reasoning-chevron', { 'button-reasoning-chevron--on': active }]"
			name="chevron"
			:size="16"
		/>
	</base-button>
</template>

<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import SvgIcon from '@/components/SvgIcon.vue'

defineProps({
	active: { type: Boolean, default: false },
	changeColor: { type: Boolean, default: false },
	showChevron: { type: Boolean, default: false }
})
</script>

<style lang="scss" scoped>
.button-reasoning {
	color: var(--text-primary);
	padding: 1px 8px;
	border-radius: var(--radius-md);
	border: none;
	background-color: var(--background-secondary);
	transition: $transition-color;
	cursor: pointer;
	@include flex-center;
	font: var(--font-label);
	&-lamp {
		margin-right: 6px;
	}
	&-chevron {
		margin-left: 6px;
		transition: $transition-transform;
		&--on {
			transform: rotate(180deg);
		}
	}
	@media (min-width: $screen-mobile) {
		&:hover {
			color: var(--control-hover);
		}
		&:active {
			color: var(--text-primary);
		}
	}

	&--on {
		color: var(--control-active);
		&:hover {
			color: var(--control-active);
		}
		&:active {
			color: var(--control-active);
		}
	}
}
</style>
